export default __webpack_public_path__ + "static/media/U_sound.d93da75a.mp3";